import { _executeModel } from 'lib/react-geo-tool/packages/react-api/src/';
import { normalizeObjectKeys, wrapModelCall } from './utils';

export function getList(props) {
  return wrapModelCall(props, null, fromRemote);
}

async function fromRemote(props) {
    const { source, spatialFilter, abortController, spatialTable, ...params } = props;
  
    return await _executeModel({
      model: 'list',
      source,
      spatialFilter,
      spatialTable,
      params,
      opts: { abortController }
    }).then((res) => normalizeObjectKeys(res));
  }
